import React from 'react';
import { connect } from 'react-redux';
import SpeechCorrect from './speechCorrect';
import SpeechIncorrect from './speechIncorrect';
import IeltsIncorrect from './ieltsIncorrect';
import SpeedDetailedFeedback from './speechDetailedFeedback';
import { compose } from 'redux';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';
const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	};
};

const SaSpeechFeedback = ({
	rightFeedbackProps: {
		score,
		defaultFeedback,
		type,
		laDefaultFeedback: { feedback },
	},
}) => {
	return (
		<section className="quiz-area-options">
			{score === 1 && type != "IELTS" ? (
				<SpeechCorrect />
			) : score === 0 && type != "IELTS" ? (
				<SpeechIncorrect />
			) : type === "IELTS" ? (
				<IeltsIncorrect />
			) :  (
				<SpeechCorrect />
			)}

			{!!defaultFeedback
				? typeof defaultFeedback === 'object' && <SpeedDetailedFeedback />
				: !!defaultFeedback && (
						<div className="tutor-feedback">
							<i className="fa fa-comments-o" aria-hidden="true"></i>
							<p>
								<span>Feedback</span>
								{defaultFeedback}
							</p>
						</div>
				  )}

			{!!feedback && (
				<div class="tutor-feedback">
					<i class="fa fa-comments-o" aria-hidden="true"></i>
					<p>
						<span>Feedback</span>
						{feedback}
					</p>
				</div>
			)}

			<input type="hidden" name="choosen-answer" className="choosen-answer" />
		</section>
	);
};
export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(SaSpeechFeedback);
